// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_jWO","col":"styles_col__1ytUs"};